import { atom } from "jotai";

export const newAspectForCompareScanAtom = atom<any | null>(null);